import { Action } from '../../../common/actions/core/action';
import { Invoice } from '../../services/invoice.model';

export class BillInfoAddDialogAction implements Action {
  constructor() {}
}



// WEBPACK FOOTER //
// src/app/buy/bill-info/add/bill-info-add-dialog.action.ts